import { hasPendingEofficeActions } from "@/utils/eofficeWorkbench.cjs";

const state = () => ({
    workbenchCounts: {
        supplyProposals: 0,
        purchaseRequests: 0,
        tickets: 0,
    },
});

const getters = {
    workbenchCounts: (state) => state.workbenchCounts,
    hasPendingActions: (state) => hasPendingEofficeActions(state.workbenchCounts),
};

const mutations = {
    setWorkbenchCounts(state, counts) {
        state.workbenchCounts = {
            supplyProposals: Number(counts?.supplyProposals) || 0,
            purchaseRequests: Number(counts?.purchaseRequests) || 0,
            tickets: Number(counts?.tickets) || 0,
        };
    },
};

export default { namespaced: true, state, getters, mutations };
